import { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { useAsync } from 'react-use';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, Card, Col, ConfigProvider, Grid, Modal, Row, Space, Tag, Typography } from 'antd';
import locale from 'antd/lib/locale/id_ID';
import CalendarC from 'src/components/Forms/Calendar';
import ImageC from 'src/components/Image';
import g from 'src/constants/urls';
import ReadArticleContainer from 'src/containers/ReadArticle';
import { decryptDLoginBE } from 'src/utils/func/encrypt';
import { renderMonth } from 'src/utils/func/kalender-kehamilan';
import dayjs from 'src/utils/moment';
import { ButtonOK } from '../Forms/Button';
import style from './style.module.less';
type DateArray = string[];
const CalendarResult = (props: any) => {
  const {
    listDay,
    onRetest
  } = props;
  const {
    xs,
    lg,
    md
  } = Grid.useBreakpoint();
  const [, setData] = useState<any>('');
  // const [uid, setUid] = useState<string>('');
  // const { mutate: updateData } = useUniqueLink({
  // onSuccess: async (response: any) => {
  // setUid(response.data.record.uid);
  // },
  // });
  // const [open, setOpen] = useState<boolean>(false);
  const [menstrualList, setMenstrualList] = useState<DateArray>([]);
  const [fertileListG, setFertileListG] = useState<DateArray>([]);
  const [fertileListG2, setFertileListG2] = useState<DateArray>([]);
  const [fertileListB, setFertileListB] = useState<DateArray>([]);
  const [fertileListB2, setFertileListB2] = useState<DateArray>([]);
  // const [ovulationList, setOvulationList] = useState<DateArray>([]);
  const [todayNew, setTodayNew] = useState<DateArray>([]);
  const [todayAttribute, setTodayAttribute] = useState<any>('');
  const [artikel, setDataArtikel] = useState<any>([]);
  useAsync(async () => {
    const filtersLike = 'order=desc&orderby=publish_date&per_page=3&page=1';
    try {
      const newArtikel = `${g.API_ARTICLE}/pre-pregnancy?${filtersLike}`;
      const optsS2 = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
      const artikelFeedback = await fetch(newArtikel, optsS2);
      const dataNewArtikel = await artikelFeedback.json();
      dataNewArtikel.status = artikelFeedback.status;
      if (dataNewArtikel.status === 200) {
        setDataArtikel(dataNewArtikel.data);
      }
    } catch (error) {}
  }, []);
  const formatDate = (date: any) => {
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
  };
  const [currentMonth, setCurrentMonth] = useState(dayjs());

  // Function to change the month
  const changeMonth = (direction: any) => {
    const newMonth = currentMonth.add(direction, 'month');
    setCurrentMonth(newMonth);
  };
  useEffect(() => {
    const menstruation: DateArray = [];
    const fertile: DateArray = [];
    const ovulation: DateArray = [];
    if (listDay) {
      listDay.ovulations.forEach((ovulationRecord: any) => {
        // Generate menstrual dates
        const mensStartDate = new Date(ovulationRecord.mens_start_date);
        const mensEndDate = new Date(ovulationRecord.mens_end_date);
        for (let d = mensStartDate; d <= mensEndDate; d.setDate(d.getDate() + 1)) {
          menstruation.push(formatDate(d));
        }

        // Generate fertile dates
        const fertileStartDate = new Date(ovulationRecord.fertile_start_date);
        const fertileEndDate = new Date(ovulationRecord.fertile_end_date);
        for (let d = fertileStartDate; d <= fertileEndDate; d.setDate(d.getDate() + 1)) {
          fertile.push(formatDate(d));
        }

        // Add ovulation date (the middle of the fertile period)
        const ovulationDate = new Date(fertileStartDate);
        ovulationDate.setDate(fertileStartDate.getDate() + 2); // Assuming ovulation is in the middle of the fertile window
        ovulation.push(formatDate(ovulationDate));
      });
    }
    const splitArrayIntoChunks = (array: any, chunkSize: any) => {
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    };
    const chunkSize = fertile.length / 3;
    const dividedArrays = splitArrayIntoChunks(fertile, chunkSize);
    const splitIntoTwo = (grouped: any) => {
      const results: any = [];
      grouped.forEach((subArray: any) => {
        const midIndex = Math.ceil(subArray.length / 2);
        const firstHalf = subArray.slice(0, midIndex);
        const secondHalf = subArray.slice(midIndex);
        results.push(firstHalf, secondHalf);
      });
      return results;
    };
    const finalResult = splitIntoTwo(dividedArrays);
    const evenDays = finalResult.filter((_: any, index: any) => index % 2 === 0);
    const oddDays = finalResult.filter((_: any, index: any) => index % 2 !== 0);
    const [G1, G2] = evenDays.map((subArray: any) => {
      const [first, second, ...rest] = subArray;
      return [[first, second], rest];
    }).reduce(([a1, a2]: any, [firstTwo, rest]: any) => {
      a1.push(firstTwo);
      if (rest.length > 0) {
        a2.push(rest);
      }
      return [a1, a2];
    }, [[], []]);
    const [B1, B2] = oddDays.map((subArray: any) => {
      const [first, ...rest] = subArray;
      return [rest.slice(-2), [first]];
    }).reduce(([a1, a2]: any, [firstTwo, rest]: any) => {
      a1.push(firstTwo);
      if (rest.length > 0) {
        a2.push(rest);
      }
      return [a1, a2];
    }, [[], []]);
    const datesArray = [];
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    datesArray.push(formattedDate);
    const TA = menstruation.includes(formattedDate) === true ? 'today1' : B1.some((innerArray: any) => innerArray.includes(formattedDate)) === true ? 'today2' : B2.some((innerArray: any) => innerArray.includes(formattedDate)) === true ? 'today3' : G1.some((innerArray: any) => innerArray.includes(formattedDate)) === true ? 'today4' : G2.some((innerArray: any) => innerArray.includes(formattedDate)) === true ? 'today5' : 'today6';
    const G1result = G1.map((innerArray: any) => innerArray.filter((date: any) => date !== formattedDate).filter((innerArray2: any) => innerArray2?.length > 0));
    const G2result = G2.map((innerArray: any) => innerArray.filter((date: any) => date !== formattedDate).filter((innerArray2: any) => innerArray2?.length > 0));
    const B1result = B1.map((innerArray: any) => innerArray.filter((date: any) => date !== formattedDate).filter((innerArray2: any) => innerArray2?.length > 0));
    const B2result = B2.map((innerArray: any) => innerArray.filter((date: any) => date !== formattedDate).filter((innerArray2: any) => innerArray2?.length > 0));
    setMenstrualList(menstruation.filter(date => date !== formattedDate));
    setData(listDay);
    // setMenstrualList(menstruation);
    setFertileListG(G1result);
    setFertileListG2(G2result);
    setFertileListB(B1result);
    setFertileListB2(B2result);
    // setOvulationList(ovulation);
    setTodayNew(datesArray);
    setTodayAttribute(TA);
  }, [listDay]);

  // const handleMakeUniqueLink = () => {
  // const lm = layoutMobile(router);
  // if (lm) {
  // delete router.query.layout;
  // }
  // if (isEmpty(uid)) {
  // updateData({ result: [data] });
  // }
  // setOpen(true);
  // };

  const currentDate = dayjs();
  // const currentYear = currentDate.year();
  const todayDate = currentDate.format('dddd D MMMM YYYY');
  const [dataLogin, setDataLogin] = useState<any>({});
  useEffect(() => {
    if (Cookies.load('d_login')) {
      const fetchData = async () => {
        const userData = decryptDLoginBE(Cookies.load('d_login'));
        setDataLogin(userData);
      };
      fetchData();
    } else {}
  }, []);
  const today = dayjs();
  const [currentMonths, setCurrentMonths] = useState(dayjs().month());
  const [currentYear, setCurrentYear] = useState(dayjs().year());

  // Fungsi untuk menangani perubahan bulan
  const handleMonthChange = (newMonth: any) => {
    setCurrentMonths(newMonth);
    // Jika bulan lebih dari 11 (Desember), tambahkan tahun
    if (newMonth > 11) {
      setCurrentMonths(0); // Kembali ke Januari
      setCurrentYear(currentYear + 1); // Tambah tahun
    } else if (newMonth < 0) {
      setCurrentMonths(11); // Kembali ke Desember
      setCurrentYear(currentYear - 1); // Kurangi tahun
    }
  };
  const disabledDate = (current: any) => {
    // Disable dates that are not in the current month
    return current.month() !== currentMonth.month() || current.year() !== currentMonth.year();
  };
  const [isModalLihatPenjelasan, setIsModalLihatPenjelasan] = useState(false);
  const showPenjelasan = (item: boolean) => {
    setIsModalLihatPenjelasan(item);
  };
  const handleCancel = () => {
    setIsModalLihatPenjelasan(false);
  };
  const OS = isAndroid ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isWindows ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isMacOs ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : isIOS ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';
  return <div className={style.calendar}>
			<h3 style={{
      opacity: !dataLogin.uid ? 0.2 : 1
    }}>Kalender Kesuburan</h3>
			<div className={style.calendarContent} style={{
      backgroundColor: '#ffffff',
      display: !dataLogin.uid ? 'block' : 'none',
      textAlign: 'center'
    }}>
				<Typography.Title level={4} style={{
        color: '#F48A8A',
        opacity: !dataLogin.uid ? 0.2 : 1
      }}>
					{today.format('MMMM') + ' ' + today.year()}
				</Typography.Title>
				<Tag className={style.tag} style={{
        opacity: !dataLogin.uid ? 0.1 : 1,
        marginBottom: '60px'
      }}>
					Hari ini, {todayDate}
				</Tag>
				<br />
				<ImageC src="/images/kalender-hpl/result-hpl.webp" height={xs ? 180 : 250} width={xs ? 180 : 250} />
				<p className={style.paragraph} style={{
        textAlign: 'center'
      }}>
					Yuk, Ma login sekarang buat buka akses perhitungannya
				</p>
				<ButtonOK style={{
        borderRadius: '16px'
      }} htmlType="submit" text={'Login Sekarang'} href="/login" />
			</div>
			<div className={style.calendarContent} style={{
      display: !dataLogin.uid ? 'none' : 'block'
    }}>
				<ConfigProvider locale={locale}>
					<CalendarC defaultValue={dayjs(listDay?.calculateFertilityPeriodResultResponse?.fertile_period_start)} dateFullCellRender={date => {
          if (menstrualList.includes(dayjs(date).format('DD-MM-YYYY'))) {
            return <div className={style.dangerDay}>{date.date()}</div>;
          }
          if (fertileListG.flat().includes(dayjs(date).format('DD-MM-YYYY'))) {
            return <div className={style.safeDayG}>{date.date()}</div>;
          }
          if (fertileListG2.flat().includes(dayjs(date).format('DD-MM-YYYY'))) {
            return <div className={style.safeDayG2}>{date.date()}</div>;
          }
          if (fertileListB.flat().includes(dayjs(date).format('DD-MM-YYYY'))) {
            return <div className={style.safeDayB}>{date.date()}</div>;
          }
          if (fertileListB2.flat().includes(dayjs(date).format('DD-MM-YYYY'))) {
            return <div className={style.safeDayB2}>{date.date()}</div>;
          }
          // if (ovulationList.includes(dayjs(date).format('DD-MM-YYYY'))) {
          // return <div className={style.toDay}>{date.date()}</div>;
          // }
          if (todayNew.includes(dayjs(date).format('DD-MM-YYYY')) && todayAttribute === 'today1') {
            return <div className={style.toDay1}>{date.date()}</div>;
          }
          if (todayNew.includes(dayjs(date).format('DD-MM-YYYY')) && todayAttribute === 'today2') {
            return <div className={style.toDay2}>{date.date()}</div>;
          }
          if (todayNew.includes(dayjs(date).format('DD-MM-YYYY')) && todayAttribute === 'today3') {
            return <div className={style.toDay3}>{date.date()}</div>;
          }
          if (todayNew.includes(dayjs(date).format('DD-MM-YYYY')) && todayAttribute === 'today4') {
            return <div className={style.toDay4}>{date.date()}</div>;
          }
          if (todayNew.includes(dayjs(date).format('DD-MM-YYYY')) && todayAttribute === 'today5') {
            return <div className={style.toDay5}>{date.date()}</div>;
          }
          if (todayNew.includes(dayjs(date).format('DD-MM-YYYY')) && todayAttribute === 'today6') {
            return <div className={style.toDay6}>{date.date()}</div>;
          }
          return <div className={style.netralDay}>{date.date()}</div>;
        }} disabledDate={disabledDate} headerRender={({
          value,
          onChange
        }) => {
          const month = value.month();
          return <div>
									<div className={style.calendarTitle}>
										<div className={style.buttonNextPrev} onClick={() => {
                const now = value.clone().month(month - 1);
                onChange(now);
                changeMonth(-1);
                handleMonthChange(currentMonths - 1);
              }}>
											<ImageC alt="Chevron Left" src="/images/default/Chevron-Left.svg" width={34} height={34} />
										</div>

										<Typography.Title level={4}>
											{renderMonth(value.month()) + ' ' + currentYear}
										</Typography.Title>

										<div className={style.buttonNextPrev} onClick={() => {
                const now = value.clone().month(month + 1);
                onChange(now);
                changeMonth(1);
                handleMonthChange(currentMonths + 1);
              }}>
											<ImageC alt="Chevron Right" src="/images/default/Chevron-Right.svg" width={34} height={34} />
										</div>
									</div>
									<div className={style.divTag}>
										<Tag className={style.tag}>
											{' '}
											Hari ini, {todayDate} |{' '}
											{todayAttribute === 'today1' ? <span>
													Masa Periode Menstruasi Mama
													<ImageC alt="masa-tidak-subur" src="/images/kalender-kesuburan/pink.svg" width={xs ? 15 : 18} height={xs ? 12 : 18} style={{
                    marginTop: xs ? '2px' : '3px'
                  }} />
												</span> : todayAttribute === 'today2' ? <span>
													Kemungkinan hamil anak laki-laki rendah
													<ImageC alt="masa-tidak-subur" src="/images/kalender-kesuburan/Lakilaki.svg" width={xs ? 15 : 18} height={xs ? 12 : 18} style={{
                    marginTop: xs ? '3px' : '3px'
                  }} />
												</span> : todayAttribute === 'today3' ? <span>
													Kemungkinan hamil anak laki-laki tinggi
													<ImageC alt="masa-tidak-subur" src="/images/kalender-kesuburan/laki2.svg" width={xs ? 15 : 30} height={xs ? 12 : 20} style={{
                    marginTop: xs ? '3px' : '5px'
                  }} />
												</span> : todayAttribute === 'today4' ? <span>
													Kemungkinan hamil anak perempuan rendah
													<ImageC alt="masa-tidak-subur" src="/images/kalender-kesuburan/Perempuan.svg" width={xs ? 15 : 18} height={xs ? 12 : 18} style={{
                    marginTop: xs ? '3px' : '3px'
                  }} />
												</span> : todayAttribute === 'today5' ? <span>
													Kemungkinan hamil anak perempuan tinggi
													<ImageC alt="masa-tidak-subur" src="/images/kalender-kesuburan/perempuan2.svg" width={xs ? 15 : 30} height={xs ? 12 : 20} style={{
                    marginTop: xs ? '3px' : '5px'
                  }} />
												</span> : todayAttribute === 'today6' ? <span>
													Tingkat Kehamilan Rendah
													<ImageC alt="masa-tidak-subur" src="/images/kalender-kesuburan/grey.svg" width={xs ? 15 : 18} height={xs ? 12 : 18} style={{
                    marginTop: xs ? '3px' : '3px'
                  }} />
												</span> : ''}
										</Tag>
									</div>
								</div>;
        }} className={style.calendarDate} fullscreen={false} />
				</ConfigProvider>
				<div>
					<Row gutter={16}>
						<Col span={8} xs={{
            span: 24,
            order: 1
          }} md={8}>
							<Card className={style.card}>
								<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/Lakilaki.svg" width={24} height={24} />
								<p className={style.paragraph}>Kemungkinan hamil anak laki-laki rendah</p>
								<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/laki2.svg" width={50} height={30} />
								<p className={style.paragraph}>Kemungkinan hamil anak laki-laki tinggi</p>
							</Card>
						</Col>
						<Col span={8} xs={{
            span: 24,
            order: 2
          }} md={8}>
							<Card className={style.card}>
								<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/Perempuan.svg" width={24} height={24} />
								<p className={style.paragraph}>Kemungkinan hamil anak perempuan rendah</p>
								<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/perempuan2.svg" width={50} height={30} />
								<p className={style.paragraph}>Kemungkinan hamil anak Perempuan tinggi</p>
							</Card>
						</Col>
						<Col span={8} xs={{
            span: 24,
            order: 3
          }} md={8}>
							<Card className={style.card}>
								<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/pink.svg" width={24} height={24} />
								<p className={style.paragraph}>Masa Periode Menstruasi Mama</p>
								<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/grey.svg" width={24} height={24} style={{
                marginTop: '3px'
              }} />
								<p className={style.paragraph}>Tingkat Kehamilan Rendah</p>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
			{/* <div className={style.calendarButton} disp>
    <button onClick={onRetest} className={style.firstButton}>
    	Hitung Ulang
    </button>
    <button onClick={handleMakeUniqueLink} className={style.secondButton}>
    	Bagikan Sekarang
    </button>
    <ModalUniqueLink open={open} setOpen={setOpen} uid={uid} />
    </div> */}
			<div style={{
      display: !dataLogin.uid ? 'none' : 'block'
    }}>
				<Row>
					<Col span={24} className={style.calendarButton}>
						<button onClick={onRetest} className={style.firstButton}>
							Hitung Ulang
						</button>
						{/* <button onClick={handleMakeUniqueLink} className={style.secondButton}></button>
       <ModalUniqueLink open={open} setOpen={setOpen} uid={uid} /> */}
					</Col>
					<Col span={24} className={style.sosmedAll}>
						<Space className={style.icons} size="middle">
							<Button onClick={() => showPenjelasan(true)} className={style.btnPenjelasan}>
								<Typography className={style.sosmed}>
									Lihat Penjelasan Lengkapnya Ma{' '}
									<ImageC src="/images/kalender-kesuburan/bintang.svg" height={xs ? 15 : 20} width={xs ? 15 : 20} />
								</Typography>
							</Button>
						</Space>
					</Col>
				</Row>
			</div>
			<div className="d-flex justify-content-center">
				{!dataLogin.uid ? '' : <ReadArticleContainer {...artikel} />}
			</div>
			{/* ===================================== Modal Lihat Semua Komentar ==================== */}
			<Modal open={isModalLihatPenjelasan} footer={null} closable={false} className={style.bgModal} width={1000}>
				<div style={{
        backgroundColor: 'red',
        marginTop: '96px',
        padding: '0'
      }}>
					<div style={{
          backgroundColor: 'transparent',
          float: 'right'
        }}>
						<Button style={{
            border: 'none',
            backgroundColor: 'transparent'
          }} onClick={() => handleCancel()}>
							<CloseCircleOutlined style={{
              color: 'grey'
            }} />
						</Button>
					</div>
					<div style={{
          backgroundColor: 'transparent',
          float: 'left',
          marginTop: lg ? '120px' : '86px'
        }}>
						<Typography className={style.title}>Penjelasan Lengkapnya di Aplikasi Ma!</Typography>
						{md ? <div>
								<Typography className={style.paragraph2}>
									Mama bisa lihat info seputar program hamil yang lebih lengkap.
								</Typography>
								<Typography className={style.paragraph2}>
									Download aplikasi Hallobumil dulu yuk, Ma!
								</Typography>
							</div> : <div>
								<Typography className={style.paragraph2}>
									Mama bisa lihat info seputar program hamil yang lebih lengkap. Download aplikasi
									Hallobumil dulu yuk, Ma!
								</Typography>
							</div>}
						<div className={style.store}>
							<Button className={style.btnlogin} onClick={() => window.open(OS)} size="large" id="download-sekarang">
								Download Sekarang
							</Button>
						</div>
					</div>
				</div>
			</Modal>
		</div>;
};
export default CalendarResult;